// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"3d088646","272":"b3acb35e","619":"582a4b8a","989":"daf95d9e"}[chunkId] + ".chunk.js";
};